<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<mat-card>
  <div class="top-bar">
    <div class="row">
      <div class="title">{{ title() }}</div>

      <ng-content></ng-content>
    </div>
  </div>
</mat-card>
